import { DownloadIcon } from 'lucide-react'

export default function DownloadLOD() {
  const handleDownload8821 = () => {
    const link = document.createElement('a')
    link.href = '/files/letter_of_direction.docx'
    link.download = 'letter_of_direction.docx'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className='w-full mx-auto p-6 bg-white rounded-lg shadow-lg'>
      <div>
        <h2 className='text-2xl font-semibold mb-4 text-center text-gray-800'>Letter of Direction</h2>
        <p className='text-center'>Make sure to download this file, send to your PEO, and upload here once filled out.</p>
        <button
          onClick={handleDownload8821}
          className='w-full flex items-center justify-center gap-2 rounded-md px-4 py-3 text-white mt-6 transition bg-ertc-primary hover:bg-ertc-primary-dark'
        >
          <DownloadIcon size={20} />
          Download Letter of Direction
        </button>
      </div>
    </div>
  )
}